import FacetedSearch from 'ps-components/redux/facetedSearch';
import apiClient from 'ps-components/lib/apiClient';
import { CLICKED_GRADE } from '../actions/ViewGradeActions';
const nameSpace = 'COST_ANALYSIS_JOBS_IN_GRADE';
const SET_JOB_IDS_START = 'SET_JOB_IDS_START',
  SET_JOB_IDS_SUCCESS = 'SET_JOB_IDS_SUCCESS',
  SET_JOB_IDS_ERROR = 'SET_JOB_IDS_ERROR',
  GET_JOB_DATA_START = 'GET_JOB_DATA_START',
  GET_JOB_DATA_SUCCESS = 'GET_JOB_DATA_SUCCESS',
  GET_JOB_DATA_ERROR = 'GET_JOB_DATA_ERROR';
const initialState = {
  filtersAreOpen: false,
  facetSelection: {},
  facets: [],
  loading: false,
  loaded: false,
  error: null,
  items: [],
  query: '',
  showAddButton: true,
  resetFacetText: 'Reset Filters',
  filters: {},
  facetIsCheckedByDefault: true,
  showZeros: false,
  sortBy: 'label',
  offset: 0,
  limit: 50
};

const options = {
  apiClient,
  graphql: { apiClient },
  getInstanceState: store => store.structureModeling.structureModelingAnalytics.JobsInRangeReducer,
  /** This will send additional facet selection parameters with the search call */
  requiredIncludes: ['org_job_id'],
  additionalSearchParams: store => {
    const { org_job_id, limit, offset } = store.structureModeling.structureModelingAnalytics.JobsInRangeReducer;
    let params = { org_job_id, limit, offset };

    return params;
  }
};
export const jobsInRangeSearch = new FacetedSearch(nameSpace, initialState, options);

function extendReducer(state, action) {
  switch (action.type) {
    case SET_JOB_IDS_SUCCESS:
      return {
        ...state,
        // include: { ...state.include, org_job_id: action.payload['org_job_id'] },
        org_job_id: action.payload['org_job_id']
      };
    case GET_JOB_DATA_SUCCESS:
      state.items.forEach((el, i) => {
        if (action.payload.results[i]) {
          el.base_50th = action.payload.results[i].base_50th;
          el.comp_ratio = action.payload.results[i].comp_ratio;
          el.range_pen = action.payload.results[i].range_pen;
          el.mid_mkt = parseFloat(action.payload.results[i].base_50th) / action.midpoint;
          el.mid_mkt = isNaN(el.mid_mkt) ? '' : el.mid_mkt;
        }
        // Add last field ehre WIP
      });
      return {
        ...state
      };
    // Needs to return both state and initialState as this facet is
    // pre-filtered by job ID
    case CLICKED_GRADE:
      return {
        ...state,
        ...initialState,
        offset: initialState.offset,
        limit: initialState.limit
      };
    default:
      return null;
  }
}

export const reducer = jobsInRangeSearch.createReducer(extendReducer, {
  searchAPI: '/api/jobRanges/search/search'
});

///////////////////////////////////
//           ACTIONS             //
///////////////////////////////////

export const jobsInRangeSearchActions = jobsInRangeSearch.getActions();
jobsInRangeSearchActions.setJobIds = (modelId, grade) => {
  return async dispatch => {
    try {
      dispatch({ type: SET_JOB_IDS_START });
      const results = await apiClient.apiGet('/api/structure-modeling/analytics/grade-view/getJobIds', {
        params: {
          grade: grade,
          modelId: modelId
        }
      });
      let newInclude = {};
      newInclude['org_job_id'] = results.data.results.map(jobId => jobId.org_job_id);
      dispatch({ type: SET_JOB_IDS_SUCCESS, payload: newInclude });
      return newInclude;
    } catch (error) {
      dispatch({ type: SET_JOB_IDS_ERROR });
      throw error;
    }
  };
};

jobsInRangeSearchActions.getJobData = (jobData, basis, minimum, midpoint, maximum) => {
  return async dispatch => {
    try {
      dispatch({ type: GET_JOB_DATA_START });
      const results = await apiClient.apiGet('/api/structure-modeling/analytics/grade-view/getJobData', {
        params: {
          jobArray: jobData,
          basis,
          minimum,
          midpoint,
          maximum
        }
      });
      dispatch({ type: GET_JOB_DATA_SUCCESS, payload: results.data, midpoint: midpoint });
      return results;
    } catch (error) {
      dispatch({ type: GET_JOB_DATA_ERROR });
      throw error;
    }
  };
};
